import React, { useState } from 'react'
// import RowCell from './NewTableCell';
import RowCell from './TableRowCell';
import { Box, Chip, IconButton, TableCell, Tooltip, Typography } from '@mui/material';
import { cloneDeep } from 'lodash';

const Row = (props) => {
    const { row, columns, renders, rowIndex, config, errorRef, helperFunction } = props
    const { actions, multipleESign, rendersRows, dynamicReadableRef } = config
    const [_, forceUpdate] = useState({});
    const render = () => (forceUpdate({}))
    if (!renders) {
        rendersRows.rows.push(([render, {}]))
        rendersRows.dynamicTypesRenderRef.push({})
    } else {
        renders[0] = render
    }
    const isDayOffRow = row?.isDayOff !== undefined ? row?.isDayOff : row?.isHoliday !== undefined ? row?.isHoliday : false;
    let isLock = !!row?.isLock
    const isNormalColumn = (colName, allowed) =>
        (Array.isArray(allowed) && allowed.includes(colName)) ||
        (typeof allowed === "string" && allowed === colName);

    const allowedColumns = config?.isDayOff?.uniqueName;

    const commonCellStyle = {
        textAlign: 'center',
        minWidth: '200px',
    }

    return (
        <>
            {
                Array.isArray(columns) && columns?.map((column, columnIndex) => {

                    let isDisable = false

                    if (multipleESign !== false) {
                        Object?.hasOwn(row, "currentESignStep")
                            ? (
                                column?.eSignStep === row?.currentESignStep
                                    ? isDisable = false : isDisable = true
                            )
                            : (row?.submitted !== undefined) && (row?.submitted === true)
                                ? isLock = true : null
                    }

                    if (column?.isReadOnly || !!dynamicReadableRef?.[rowIndex]?.[column?.uniqueName]) {
                        isDisable = true
                    }

                    if (
                        (isDayOffRow &&
                            column?.uniqueName !== "srNo" &&
                            !isNormalColumn(column?.uniqueName, allowedColumns) ||
                            (column?.isHoliday)
                        )
                    ) {
                        return (
                            <TableCell sx={[commonCellStyle]} key={`column-${columnIndex}`}>
                                <Typography
                                    variant="body2"
                                    sx={{ fontWeight: "bold", color: "red", textAlign: "center" }}
                                >
                                    Day Off
                                </Typography>
                            </TableCell>
                        );
                    } else {
                        if (Array.isArray(row) && !Object.keys(row).includes(column.uniqueName)) {
                            ["dropdown", "dynamicDropdown"].includes(column?.type)
                                ? row[column?.uniqueName] = ""
                                : row[column?.uniqueName] = ""
                        }
                        return (
                            <TableCell
                                sx={[commonCellStyle,
                                    { ...(column?.sx ? column?.sx : {}) }
                                ]}
                                key={`row-column-${columnIndex}`} >
                                <RowCell
                                    row={row}
                                    column={column}
                                    renders={renders ?? rendersRows.rows[rowIndex]}
                                    rowIndex={rowIndex}
                                    columnIndex={columnIndex}
                                    helperFunction={helperFunction}
                                    config={config}
                                    errorRef={errorRef}
                                    isLock={isLock}
                                    isDisable={isDisable}
                                />
                            </TableCell>
                        )
                    }
                })
            }
            {
                actions !== false && (
                    <TableCell sx={[commonCellStyle]}>
                        {!isLock ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}
                            >
                                {
                                    actions?.map((actionBtn, actionIdx) => {
                                        const actBtnVisible =
                                            typeof actionBtn?.isVisible === "boolean"
                                                ? actionBtn?.isVisible
                                                : actionBtn.isVisible(cloneDeep(row), rowIndex, actionBtn)
                                        const actBtnDisable =
                                            typeof actionBtn?.isActive === "boolean"
                                                ? actionBtn?.isActive
                                                : actionBtn.isActive(cloneDeep(row), rowIndex, actionBtn)
                                        return (
                                            !!actBtnVisible && (<Tooltip key={actionIdx} title={actionBtn?.tooltip || actionBtn?.name} arrow>
                                                <IconButton
                                                    color={actionBtn?.color}
                                                    onClick={() => {
                                                        actionBtn?.onClick(cloneDeep(row), rowIndex, actionBtn, rendersRows)
                                                    }}
                                                    disabled={!actBtnDisable}
                                                >
                                                    {actionBtn?.icon}
                                                </IconButton>
                                            </Tooltip>)
                                        )
                                    })
                                }
                            </Box>
                        ) : (
                            <Chip
                                color='error'
                                label='Actions are Lock !'
                            />
                        )}

                    </TableCell>
                )
            }
        </>
    )
}

export default Row
